export enum AuthMismatchEvent {
  TOKEN_MISMATCH = 'AuthMismatchEvent:token_mismatch'
}
